import React from 'react';
import RangeList from 'components/Tvendo/Commissions/DataMaster/Range/List.js';

export default function Range() {
  return <RangeList />;
}
